import { Navigate, Outlet } from "react-router-dom";
import Login from "../pages/Auth/Login";
import { handleLogin } from "../helper/auth";

const PrivateOutlet = () => {
  // const token = localStorage.getItem("token");

  // if (token) {
  //   // handleLogin(token);
  // } else {
  //   console.log(2);

  //   return <Navigate to="/login" replace />;
  // }

  const auth = true;

  return auth ? <Outlet /> : <Login />;
};
export default PrivateOutlet;
